<template>
  <BrDocumentListItem
    :item="item"
    :variant="openMode"
    :display-name-en="displayNameEn"
    :display-name-local="displayNameLocal"
    :thumb-url="thumbUrl"
    :is-current-display="isCurrentDisplay"
    :can-edit-name="canEditName"
    :has-admin-footer="showActions"
    :expiry-context-list="expiryContextList"
    @preview="$emit('preview', item)"
    @edit-name="$emit('edit-name', item)"
    @set-as-current="$emit('set-as-current', item)"
    @reupload="$emit('reupload', $event)"
    @cancel="$emit('cancel', $event)"
    @invalidate="$emit('invalidate', $event)"
    @contact="$emit('contact', $event)"
  >
    <template v-if="showActions" #admin-footer>
      <BrAdminItemActions
        :item="item"
        :draft="draft"
        :processing="processing"
        :proceed-locked="proceedLocked"
        :templates="templates"
        :show-direct-reject-bar="showDirectRejectBar"
        :can-change-to-reject="canChangeToReject"
        :is-last-in-effect-approved="isLastInEffectApproved"
        @update:rejected="(rejected) => $emit('update:rejected', rejected)"
        @update:reason="(value) => $emit('update:reason', value)"
        @clear-reason-error="$emit('clear-reason-error')"
        @proceed="$emit('proceed')"
        @reject-last-blocked="$emit('reject-last-blocked')"
      />
    </template>
  </BrDocumentListItem>
</template>

<script>
import BrDocumentListItem from '../../../businessDocuments/components/BrDocumentListItem.vue';
import BrAdminItemActions from './BrAdminItemActions.vue';

export default {
  name: 'BrAdminListCard',
  components: { BrDocumentListItem, BrAdminItemActions },
  props: {
    item: { type: Object, required: true },
    draft: { type: Object, default: null },
    displayNameEn: { type: String, default: '' },
    displayNameLocal: { type: String, default: '' },
    thumbUrl: { type: String, default: '' },
    isCurrentDisplay: { type: Boolean, default: false },
    canEditName: { type: Boolean, default: false },
    showActions: { type: Boolean, default: false },
    processing: { type: Boolean, default: false },
    proceedLocked: { type: Boolean, default: false },
    templates: { type: Array, default: () => [] },
    showDirectRejectBar: { type: Boolean, default: false },
    canChangeToReject: { type: Boolean, default: false },
    isLastInEffectApproved: { type: Boolean, default: false },
    expiryContextList: { type: Array, default: () => [] },
    openMode: { type: String, default: '' },
  },
};
</script>
